module.exports = __webpack_public_path__ + "assets/word_manage_default.caab7c4a.svg";